import BopisStoresRepository from './BopisStoresRepository';

export default BopisStoresRepository;
